import React from 'react';
import styles from '../css/FeeSummary.module.css';

export default function FeeSummaryCard({ dispensingFee = 'R26.67', gross = 'R219.50' }) {
  return (
    <div className={styles.card}>
      <div className={styles.row}>
        <span className={styles.label}>Dispensing Fee</span>
        <span className={styles.value}>{dispensingFee}</span>
      </div>
      <div className={styles.rowStrong}>
        <span className={styles.label}>Gross</span>
        <span className={styles.valueStrong}>{gross}</span>
      </div>
    </div>
  );
}
